require("es6-promise").polyfill()

import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './style/index.scss'
import App from './App'
import axios from 'axios';
import router from './router'
import * as WPS from './static/open-jssdk-v1.2.0.es' 
import VueClipboard from 'vue-clipboard2'

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.wps = WPS.default
axios.defaults.baseURL = window.location.origin
Vue.prototype.$axios = axios
Vue.http = Vue.prototype.$http = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js